module.exports = __webpack_public_path__ + "static/media/sontho-1.dcb4270a.png";